interface ProgressBarProps {
  percentage: number;
  sectionLabel?: string;
}

export function ProgressBar({ percentage, sectionLabel }: ProgressBarProps) {
  return (
    <div className="w-full">
      <div className="flex items-center justify-between mb-2 text-sm">
        <span className="text-slate-600">{sectionLabel ?? 'Your submission'}</span>
        <span className="font-medium text-slate-900">{Math.round(percentage)}% complete</span>
      </div>
      <div className="h-2 w-full overflow-hidden rounded-full bg-slate-100">
        <div
          className="h-full rounded-full bg-gradient-to-r from-blue-500 to-blue-600 transition-all duration-500 ease-out"
          style={{ width: `${Math.max(2, Math.min(100, percentage))}%` }}
        />
      </div>
    </div>
  );
}
